var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"readiness-circle",style:(_setup.circleStyle),attrs:{"role":"img","aria-label":_setup.ariaLabel}},[_c('img',{staticClass:"readiness-circle__icon",attrs:{"src":_setup.iconSrc,"alt":"","aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }